var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-data" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("nav", { staticClass: "navbar" }, [
        _c(
          "ul",
          { staticClass: "nav" },
          _vm._l(_vm.tabs, function (tab, index) {
            return _c(
              "li",
              {
                key: tab + "_" + index,
                staticClass: "nav-item tab-item",
                on: {
                  click: function ($event) {
                    return _vm.setActive(tab)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    class: {
                      active:
                        _vm.$isset(_vm.currentTab) &&
                        _vm.currentTab.key === tab.key,
                    },
                    attrs: { href: "#" + _vm.currentTab.key },
                  },
                  [_vm._v(_vm._s(tab.name))]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c("hr", { staticClass: "rounded mx-3" }),
    ]),
    _c(
      "div",
      {
        staticClass: "card-body data-load",
        class: { "sk-loading": _vm.isLoading },
      },
      [
        _vm.isLoading ? _c("sk-spinner") : _vm._e(),
        _vm._t("data", null, { tab: _vm.currentTab }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }